window.KBAvailability = (() => {
  const strings = JSON.parse(document.querySelector('[data-kb-availability-text]')?.textContent || '{}');
  const text = (key, values = {}) => Object.entries(values).reduce((result, [name, value]) => result.replaceAll(`[${name}]`, value), strings[key] || '');
  const state = ({ complete = true, color = '', weight = '', large = false, exists = false, available = false }) => {
    if (!complete) return { kind: 'pending', message: text(!color && !weight ? 'choose_options' : !color ? 'choose_color' : 'choose_weight') };
    if (large && weight !== '300 g') return { kind: 'unavailable', message: `${text('unavailable_weight', { weight })} · ${text('only_300')}` };
    if (available) return { kind: 'available', message: '' };
    return { kind: 'unavailable', message: text(exists ? 'sold_out' : weight ? 'unavailable_weight' : 'unavailable', { weight }) };
  };
  const option = (input, available, exists, color = '') => {
    const label = input.closest('label');
    if (!label) return;
    let note = label.querySelector('[data-option-availability]');
    if (!note) { note = document.createElement('small'); note.dataset.optionAvailability = ''; note.className = 'kb-option-availability'; label.append(note); }
    note.hidden = available;
    note.textContent = available ? '' : text(exists ? 'sold_out' : color ? 'unavailable_color' : 'unavailable', { color });
  };
  const size = (input, status) => {
    const card = input.closest('[data-size-card], .kb-order__size');
    if (!card) return;
    let note = card.querySelector('[data-size-unavailable]');
    if (!note) { note = document.createElement('small'); note.dataset.sizeUnavailable = ''; note.className = 'kb-size-card__unavailable'; card.append(note); }
    note.hidden = status.kind === 'available';
    note.textContent = status.message;
    card.dataset.availability = status.kind;
    card.classList.toggle('is-unavailable', status.kind === 'unavailable');
    if (input.id) { note.id = `${input.id}-availability`; input.setAttribute('aria-describedby', note.id); }
  };
  const select = element => [...element.options].forEach(option => {
    option.dataset.availabilityLabel ||= option.textContent;
    option.textContent = option.dataset.availabilityLabel + (option.disabled ? ` · ${text('unavailable')}` : '');
  });
  return { text, state, option, size, select };
})();

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-search-open]');
  const search = document.querySelector('#kb-search');
  const searchInput = search?.querySelector('input[type=search]');
  const suggestions = search?.querySelector('#kb-suggestions');
  let searchTimer;
  let searchRequest;
  const closeSearch = () => {
    if (!search) return;
    search.hidden = true;
    suggestions.hidden = true;
    toggle?.setAttribute('aria-expanded', 'false');
    searchInput?.setAttribute('aria-expanded', 'false');
    searchRequest?.abort();
    document.body.classList.remove('kb-search-open');
  };
  toggle?.addEventListener('click', () => {
    search.hidden = !search.hidden;
    toggle.setAttribute('aria-expanded', String(!search.hidden));
    document.body.classList.toggle('kb-search-open', !search.hidden);
    if (!search.hidden) searchInput?.focus();
  });
  search?.querySelector('[data-search-close]')?.addEventListener('click', closeSearch);
  document.addEventListener('keydown', event => { if (event.key === 'Escape') closeSearch(); });
  document.addEventListener('click', event => {
    if (search && !search.hidden && !search.contains(event.target) && !toggle.contains(event.target)) closeSearch();
  });
  searchInput?.addEventListener('input', () => {
    clearTimeout(searchTimer);
    searchRequest?.abort();
    const term = searchInput.value.trim();
    suggestions.replaceChildren();
    suggestions.hidden = true;
    searchInput.setAttribute('aria-expanded', 'false');
    if (term.length < 2) return;
    searchTimer = setTimeout(async () => {
      searchRequest = new AbortController();
      try {
        const root = search.dataset.root.endsWith('/') ? search.dataset.root : `${search.dataset.root}/`;
        const url = `${root}search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=5`;
        const response = await fetch(url, { signal: searchRequest.signal });
        if (!response.ok) return;
        const data = await response.json();
        if (searchInput.value.trim() !== term) return;
        const products = data.resources?.results?.products || [];
        for (const product of products) {
          const link = document.createElement('a');
          link.href = product.url;
          const imageUrl = product.featured_image?.url || product.featured_image || product.image;
          if (typeof imageUrl === 'string' && imageUrl.startsWith('https://')) {
            const image = document.createElement('img');
            image.src = imageUrl;
            image.alt = '';
            image.loading = 'lazy';
            link.append(image);
          }
          const title = document.createElement('strong');
          title.textContent = product.title;
          link.append(title);
          link.setAttribute('role', 'option');
          suggestions.append(link);
        }
        if (!products.length) {
          const empty = document.createElement('p');
          empty.textContent = search.dataset.empty;
          suggestions.append(empty);
        }
        suggestions.hidden = false;
        searchInput.setAttribute('aria-expanded', 'true');
      } catch (error) {
        if (error.name !== 'AbortError') suggestions.hidden = true;
      }
    }, 180);
  });

  const campaignBar = document.querySelector('[data-campaign-bar]');
  if (campaignBar?.dataset.campaignEnd) {
    const end = Date.parse(campaignBar.dataset.campaignEnd);
    const countdown = campaignBar.querySelector('[data-campaign-countdown]');
    if (!Number.isNaN(end)) {
      const updateCountdown = () => {
        const remaining = Math.max(0, end - Date.now());
        if (remaining === 0 && campaignBar.dataset.hideExpired === 'true') { campaignBar.hidden = true; return; }
        if (!remaining) { countdown.hidden = true; return; }
        const days = Math.floor(remaining / 86400000);
        const hours = Math.floor((remaining % 86400000) / 3600000);
        const minutes = Math.floor((remaining % 3600000) / 60000);
        countdown.textContent = `${days} ${countdown.dataset.days} · ${hours} ${countdown.dataset.hours} · ${minutes} ${countdown.dataset.minutes}`;
        countdown.hidden = false;
      };
      updateCountdown();
      setInterval(updateCountdown, 60000);
    }
  }

  const cartDialog = document.querySelector('#kb-cart-drawer');
  const cartRoot = cartDialog?.dataset.root.endsWith('/') ? cartDialog.dataset.root : `${cartDialog?.dataset.root}/`;
  const cartItems = cartDialog?.querySelector('[data-cart-items]');
  const cartError = cartDialog?.querySelector('[data-cart-error]');
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'es-MX', { style: 'currency', currency: window.Shopify?.currency?.active || 'MXN' }).format(cents / 100);
  let previousCartQuantities = new Map();
  const renderCart = cart => {
    if (!cartDialog) return;
    cartError.hidden = true;
    cartItems.replaceChildren();
    document.querySelectorAll('[data-cart-badge]').forEach(badge => { badge.textContent = cart.item_count; });
    cartDialog.querySelector('[data-cart-count]').textContent = `(${cart.item_count})`;
    cartDialog.querySelector('[data-cart-subtotal]').textContent = money(cart.total_price);
    document.querySelectorAll('[data-kb-shipping]').forEach(panel => {
      const free = cart.total_price >= Number(panel.dataset.threshold);
      panel.querySelector('[data-shipping-standard]').textContent = free ? panel.dataset.free : money(Number(panel.dataset.standard));
      panel.querySelector('[data-shipping-express]').textContent = money(Number(panel.dataset.express));
      const message = panel.querySelector('[data-shipping-progress]');
      message.textContent = free ? panel.dataset.reached : panel.dataset.remaining.replace('[amount]', money(Number(panel.dataset.threshold) - cart.total_price));
      panel.classList.toggle('is-free', free);
    });
    const savings = cartDialog.querySelector('[data-cart-savings]');
    savings.hidden = !(cart.total_discount > 0);
    if (cart.total_discount > 0) savings.querySelector('[data-cart-savings-amount]').textContent = money(cart.total_discount);
    cartDialog.querySelector('[data-cart-empty]').hidden = cart.item_count > 0;
    cartDialog.querySelector('[data-cart-filled]').hidden = cart.item_count === 0;
    for (const item of cart.items) {
      const row = document.createElement('article');
      const isBundle=item.product_type==='Bundle'&&item.properties?._kb_bundle==='inicial';
      const bundleLabels=document.querySelector('[data-bundle-cart-labels]')?.dataset||{};
      row.className = 'kb-cart-drawer__item'+(isBundle?' kb-bundle-box':'');
      if (item.quantity > (previousCartQuantities.get(item.key) || 0)) row.classList.add('kb-cart-item-added');
      const imageLink = document.createElement('a');
      imageLink.href = item.url;
      imageLink.className = 'kb-cart-drawer__image';
      const imageUrl = item.featured_image?.url || item.image;
      if(isBundle){const icon=document.createElement('span');icon.className='kb-bundle-box__icon';icon.innerHTML='<svg viewBox="0 0 64 64" width="52" height="52" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linejoin="round" aria-hidden="true"><path d="m32 7 23 12v26L32 57 9 45V19Z"/><path d="m9 19 23 12 23-12M32 31v26M21 13l23 12v12l-8 4V29"/></svg>';icon.setAttribute('aria-hidden','true');imageLink.append(icon);}
      else if (imageUrl) {
        const img = document.createElement('img');
        img.src = imageUrl;
        img.alt = item.featured_image?.alt || `${item.product_title} ${item.variant_title || ''}`;
        img.loading = 'lazy';
        imageLink.append(img);
      }
      const info = document.createElement('div');
      info.className = 'kb-cart-drawer__info';
      const title = document.createElement('a');
      title.href = item.url;
      title.className = 'kb-cart-drawer__title';
      title.textContent = item.product_title;
      info.append(title);
      if (item.variant_title && item.variant_title !== 'Default Title') {
        const variant = document.createElement('p');
        variant.className = 'kb-cart-drawer__variant';
        variant.textContent = item.variant_title;
        info.append(variant);
      }
      const properties = document.createElement('div');
      properties.className = 'kb-line-properties';
      Object.entries(item.properties || {}).forEach(([key, value]) => {
        if (key.startsWith('_') || value === '' || value == null) return;
        const detail = document.createElement('p');
        if (typeof value === 'string' && /^(https?:)?\/\/[^/]*shopify\.com\//i.test(value)) {
          const link = document.createElement('a'); link.href = value; link.target = '_blank'; link.rel = 'noopener'; link.textContent = key; detail.append(link);
        } else { detail.textContent = `${key}: ${value}`; }
        properties.append(detail);
      });
      if(isBundle){
        const note=document.createElement('p');note.className='kb-bundle-box__note';note.textContent=bundleLabels.note||'';info.append(note);
        const box=document.createElement('details');box.className='kb-bundle-box__details';const summary=document.createElement('summary');summary.textContent=bundleLabels.details||item.product_title;box.append(summary);
        const shirts=document.createElement('div');shirts.className='kb-bundle-box__shirts';
        for(let n=1;n<=4;n++){const desc=item.properties?.[`Playera ${n}`];if(!desc)continue;const row=document.createElement('div');row.className='kb-bundle-box__shirt';let src='';try{const u=new URL(item.properties?.[`_kb_bundle_image_${n}`]||'',window.location.origin);if(u.protocol==='https:'&&(u.hostname===window.location.hostname||u.hostname==='cdn.shopify.com'))src=u.href;}catch{}if(src){const img=document.createElement('img');img.src=src;img.alt='';img.loading='lazy';row.append(img);}const text=document.createElement('p');text.textContent=desc;row.append(text);shirts.append(row);}
        box.append(shirts);[...properties.children].forEach(el=>{if(/^Playera [1-4]:/.test(el.textContent))el.remove();});box.append(properties);info.append(box);
      }else if (properties.childElementCount) info.append(properties);
      const unitPrice = Number(item.final_price ?? item.price);
      const originalUnitPrice = Number(item.original_price ?? item.price);
      const linePrice = Number(item.final_line_price ?? item.line_price);
      const originalLinePrice = Number(item.original_line_price ?? item.line_price);
      const lineDiscount = Math.max(0, originalLinePrice - linePrice);
      const price = document.createElement('div');
      price.className = 'kb-line-unit';
      if (lineDiscount > 0 && originalUnitPrice > unitPrice) {
        const original = document.createElement('del');
        original.textContent = money(originalUnitPrice);
        price.append(original);
      }
      const current = document.createElement('strong');
      current.textContent = money(unitPrice);
      const unitLabel = document.createElement('span');
      unitLabel.textContent = isBundle ? bundleLabels.unit : cartDialog.dataset.unit;
      price.append(current, unitLabel);
      info.append(price);
      if (lineDiscount > 0) {
        const discount = document.createElement('p');
        discount.className = 'kb-line-discount';
        discount.textContent = `${cartDialog.dataset.discount}: −${money(lineDiscount)}`;
        info.append(discount);
      }
      const lineTotal = document.createElement('p');
      lineTotal.className = 'kb-line-total';
      const totalLabel = document.createElement('span');
      totalLabel.textContent = cartDialog.dataset.lineTotal;
      const totalValue = document.createElement('strong');
      totalValue.textContent = money(linePrice);
      lineTotal.append(totalLabel, totalValue);
      info.append(lineTotal);
      const actions = document.createElement('div');
      actions.className = 'kb-cart-drawer__actions';
      const quantity = document.createElement('div');
      quantity.className = 'kb-cart-drawer__quantity';
      const count = document.createElement('input');
      count.type = 'number';
      count.min = '0';
      count.step = '1';
      count.inputMode = 'numeric';
      count.value = item.quantity;
      count.dataset.cartInput = '';
      count.dataset.cartKey = item.key;
      count.dataset.cartQuantity = item.quantity;
      count.setAttribute('aria-label', `${cartDialog.dataset.quantity}: ${item.product_title}`);
      const adjust = (label, symbol, delta) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = symbol;
        button.setAttribute('aria-label', `${label} ${item.product_title}`);
        button.addEventListener('click', () => {
          clearTimeout(quantityTimers.get(count));
          const entered = count.value.trim() === '' ? item.quantity : Number(count.value);
          const base = Number.isSafeInteger(entered) && entered >= 0 ? entered : item.quantity;
          changeCart(item.key, Math.max(0, base + delta));
        });
        return button;
      };
      quantity.append(adjust('−', '−', -1), count, adjust('+', '+', 1));
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'kb-cart-drawer__remove';
      remove.textContent = cartDialog.dataset.remove;
      remove.addEventListener('click', () => changeCart(item.key, 0));
      actions.append(quantity, remove);
      info.append(actions);
      row.append(imageLink, info);
      cartItems.append(row);
    }
    previousCartQuantities = new Map(cart.items.map(item => [item.key, item.quantity]));
    document.dispatchEvent(new CustomEvent('kb:cart-updated', { detail: cart }));
  };
  const showCartError = error => {
    const message = error?.message || cartDialog?.dataset.error;
    [cartError, document.querySelector('[data-cart-page-error]')].filter(Boolean).forEach(element => { element.textContent = message; element.hidden = false; });
  };
  const getCart = async () => {
    const response = await fetch(`${cartRoot}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error(cartDialog.dataset.error);
    return response.json();
  };
  const openCart = async () => {
    if (!cartDialog || cartBusy) return;
    closeSearch();
    if (!cartDialog.open) cartDialog.showModal();
    cartItems.replaceChildren();
    cartDialog.querySelector('[data-cart-empty]').hidden = true;
    cartDialog.querySelector('[data-cart-filled]').hidden = true;
    cartError.hidden = true;
    const loading = document.createElement('p');
    loading.className = 'kb-cart-drawer__loading';
    loading.textContent = '…';
    cartItems.append(loading);
    try { renderCart(await getCart()); } catch (error) { cartItems.replaceChildren(); showCartError(error); }
  };
  document.addEventListener('kb:open-cart', () => openCart());
  let cartBusy = false;
  const quantityTimers = new WeakMap();
  const refreshCartPage = async data => {
    const page = document.querySelector('[data-kb-cart-page]');
    if (!page) return true;
    const sectionId = page.dataset.sectionId;
    let html = data.sections?.[sectionId];
    try {
      if (typeof html !== 'string') {
        const url = new URL(window.location.href);
        url.searchParams.set('sections', sectionId);
        const response = await fetch(url, { headers: { Accept: 'application/json' }, cache: 'no-store' });
        if (!response.ok) throw new Error('Cart section unavailable');
        html = (await response.json())[sectionId];
      }
      if (typeof html !== 'string') throw new Error('Missing cart section');
      const updated = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-kb-cart-page]');
      if (!updated) throw new Error('Missing cart markup');
      page.replaceWith(updated);
      return true;
    } catch (_) {
      window.location.reload();
      return false;
    }
  };
  const changeCart = async (key, quantity) => {
    if (cartBusy) return;
    if (!Number.isSafeInteger(quantity) || quantity < 0) { showCartError(new Error(cartDialog.dataset.invalidQuantity)); return; }
    cartBusy = true;
    const activeInput = document.activeElement?.matches('[data-cart-input]') ? document.activeElement : null;
    const focusScope = activeInput?.closest('[data-kb-cart-page]') ? '[data-kb-cart-page]' : '#kb-cart-drawer';
    const controls = [...document.querySelectorAll('#kb-cart-drawer [data-cart-items] button, #kb-cart-drawer [data-cart-items] input, #kb-cart-drawer [name="checkout"], [data-kb-cart-page] button, [data-kb-cart-page] input')].map(element => ({ element, disabled: element.disabled }));
    controls.forEach(({ element }) => { element.disabled = true; });
    cartItems?.setAttribute('aria-busy', 'true');
    document.querySelector('[data-kb-cart-page]')?.setAttribute('aria-busy', 'true');
    try {
      const payload = { id: key, quantity };
      const page = document.querySelector('[data-kb-cart-page]');
      if (page) { payload.sections = [page.dataset.sectionId]; payload.sections_url = window.location.pathname; }
      const response = await fetch(`${cartRoot}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || cartDialog.dataset.error);
      if (!(await refreshCartPage(data))) return;
      renderCart(data);
      if (activeInput && quantity > 0) {
        const restored = [...document.querySelectorAll(`${focusScope} [data-cart-input]`)].find(input => input.dataset.cartKey === key);
        restored?.focus({ preventScroll: true });
      }
    } catch (error) {
      showCartError(error);
      document.querySelectorAll('[data-cart-input]').forEach(input => { input.value = input.dataset.cartQuantity; });
    } finally {
      controls.forEach(({ element, disabled }) => { if (element.isConnected) element.disabled = disabled; });
      cartItems?.removeAttribute('aria-busy');
      document.querySelector('[data-kb-cart-page]')?.removeAttribute('aria-busy');
      cartBusy = false;
    }
  };
  const commitQuantity = input => {
    clearTimeout(quantityTimers.get(input));
    if (!input.isConnected || cartBusy) return;
    const value = input.value.trim();
    const quantity = Number(value);
    if (!value || !Number.isSafeInteger(quantity) || quantity < 0 || !input.validity.valid) {
      input.value = input.dataset.cartQuantity;
      showCartError(new Error(cartDialog.dataset.invalidQuantity));
      return;
    }
    if (quantity !== Number(input.dataset.cartQuantity)) changeCart(input.dataset.cartKey, quantity);
  };
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-cart-input]')) return;
    const input = event.target;
    clearTimeout(quantityTimers.get(input));
    quantityTimers.set(input, setTimeout(() => commitQuantity(input), 0));
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Enter' || !event.target.matches('[data-cart-input]')) return;
    event.preventDefault();
    commitQuantity(event.target);
  });
  document.addEventListener('click', event => {
    const button = event.target.closest('#kb-cart-drawer [name="checkout"], [data-kb-cart-page] [name="checkout"], [data-kb-cart-page] [name="update"]');
    if (!button) return;
    if (cartBusy) { event.preventDefault(); return; }
    const scope = button.closest('[data-kb-cart-page]') || cartDialog;
    const pending = [...scope.querySelectorAll('[data-cart-input]')].find(input => input.value.trim() === '' || Number(input.value) !== Number(input.dataset.cartQuantity));
    if (pending) { event.preventDefault(); commitQuantity(pending); }
  });
  let checkoutPending = false;
  document.addEventListener('submit', async event => {
    const checkoutForm = event.target;
    if (!checkoutForm.matches('#kb-cart-drawer form, [data-kb-cart-page] form') || event.submitter?.name !== 'checkout' || checkoutForm.dataset.kbValidated === 'true') return;
    event.preventDefault();
    if (checkoutPending || cartBusy) return;
    checkoutPending = true;
    try {
      const cart = await getCart();
      if (cart.items.some(item => item.properties?._kb_minimum === '3') && cart.items.filter(item=>item.product_type!=='Bundle'&&item.properties?._kb_bundle!=='inicial').reduce((n,item)=>n+item.quantity,0) < 3) {
        showCartError(new Error(cartDialog.dataset.wholesaleMinimum));
      } else {
        checkoutForm.dataset.kbValidated = 'true';
        checkoutForm.requestSubmit(event.submitter);
      }
    } catch (error) { showCartError(error); }
    finally { checkoutPending = false; }
  });
  document.querySelectorAll('[data-cart-open]').forEach(link => link.addEventListener('click', event => { if (!cartDialog) return; event.preventDefault(); openCart(); }));
  cartDialog?.querySelectorAll('[data-cart-close]').forEach(button => button.addEventListener('click', () => cartDialog.close()));
  cartDialog?.addEventListener('click', event => { if (event.target === cartDialog) cartDialog.close(); });

  const gallery = document.querySelector('[data-product-gallery]');
  const galleryThumbs = [...(gallery?.querySelectorAll('[data-gallery-thumb]') || [])];
  const selectGalleryImage = button => {
    const mainImage = gallery?.querySelector('#kb-product-image');
    const template = button?.querySelector('[data-gallery-template]');
    const sourceImage = template?.content.querySelector('img');
    if (!mainImage || !sourceImage) return;
    const nextImage = sourceImage.cloneNode(true);
    mainImage.replaceWith(nextImage);
    galleryThumbs.forEach(thumb => thumb.removeAttribute('aria-current'));
    button.setAttribute('aria-current', 'true');
    const count = gallery.querySelector('[data-gallery-count]');
    if (count) count.textContent = `${button.dataset.imageIndex} / ${galleryThumbs.length}`;
  };
  const moveGallery = direction => {
    if (galleryThumbs.length < 2) return;
    const index = Math.max(0, galleryThumbs.findIndex(button => button.getAttribute('aria-current') === 'true'));
    selectGalleryImage(galleryThumbs[(index + direction + galleryThumbs.length) % galleryThumbs.length]);
  };
  galleryThumbs.forEach(button => button.addEventListener('click', () => selectGalleryImage(button)));
  gallery?.querySelector('[data-gallery-prev]')?.addEventListener('click', () => moveGallery(-1));
  gallery?.querySelector('[data-gallery-next]')?.addEventListener('click', () => moveGallery(1));
  gallery?.addEventListener('keydown', event => {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    event.preventDefault();
    moveGallery(event.key === 'ArrowLeft' ? -1 : 1);
    galleryThumbs.find(button => button.getAttribute('aria-current') === 'true')?.focus({ preventScroll: true });
  });
  let swipeStart;
  const galleryStage = gallery?.querySelector('[data-gallery-stage]');
  galleryStage?.addEventListener('touchstart', event => {
    if (event.touches.length !== 1 || event.target.closest('button')) { swipeStart = null; return; }
    swipeStart = { x: event.touches[0].clientX, y: event.touches[0].clientY };
  }, { passive: true });
  galleryStage?.addEventListener('touchend', event => {
    if (!swipeStart) return;
    const touch = event.changedTouches[0];
    const deltaX = touch.clientX - swipeStart.x;
    const deltaY = touch.clientY - swipeStart.y;
    swipeStart = null;
    if (Math.abs(deltaX) >= 55 && Math.abs(deltaX) > Math.abs(deltaY) * 1.5) moveGallery(deltaX < 0 ? 1 : -1);
  }, { passive: true });
  galleryStage?.addEventListener('touchcancel', () => { swipeStart = null; });

  let lastGalleryColor = '';
  const syncGalleryColor = (color, hasVariantImage) => {
    const normalized = String(color || '').trim().toLowerCase();
    const canonical = ['blanco', 'blanca', 'white'].includes(normalized) ? 'Blanco' : ['negro', 'negra', 'black'].includes(normalized) ? 'Negro' : '';
    if (!canonical || canonical === lastGalleryColor) return;
    lastGalleryColor = canonical;
    if (hasVariantImage) return;
    const current = galleryThumbs.find(button => button.getAttribute('aria-current') === 'true');
    if (current?.dataset.imageKey?.startsWith(`${canonical}|`)) return;
    const thumb = galleryThumbs.find(button => button.dataset.imageKey === `${canonical}|front`);
    if (thumb) selectGalleryImage(thumb);
  };

  const form = document.querySelector('[data-product-form]');
  if (form && !form.querySelector('[data-size-picker]')) {
    const variants = JSON.parse(document.querySelector('[data-kb-variants]')?.textContent || '[]');
    const optionGroups = [...form.querySelectorAll('[data-option-position]')];
    const idField = form.querySelector('[data-variant-id]');
    const submit = form.querySelector('[data-add-button]');
    const messages = form.querySelector('[data-product-message]')?.dataset || {};
    const errorMessage = form.querySelector('[data-product-error]');
    let lastVariantImage;
    const selections = () => optionGroups.map(group => group.querySelector('input:checked')?.value || '');
    const selectedVariant = () => {
      const selected = selections();
      if (selected.some(value => !value)) return null;
      return variants.find(variant => selected.every((value, index) => variant.options[index] === value)) || null;
    };
    const showProductError = message => {
      errorMessage.textContent = message;
      errorMessage.hidden = false;
      errorMessage.focus();
    };
    const sync = () => {
      const selected = selections();
      const variant = selectedVariant();
      idField.value = variant?.id || '';
      submit.disabled = messages.productAvailable === 'false';
      submit.textContent = variant && !variant.available ? submit.dataset.soldOutText : submit.dataset.availableText;
      optionGroups.forEach((group, index) => {
        group.querySelector('[data-option-choice]').textContent = selected[index] || '';
        group.querySelectorAll('input[type=radio]').forEach(input => {
          const possible = variants.some(candidate => candidate.available && candidate.options[index] === input.value && selected.every((value, other) => other === index || !value || candidate.options[other] === value));
          input.disabled = !possible && !input.checked;
          input.closest('label')?.classList.toggle('kb-option-choice--unavailable', !possible);
          const exists = variants.some(candidate => candidate.options[index] === input.value && selected.every((value, other) => other === index || !value || candidate.options[other] === value));
          window.KBAvailability.option(input, possible, exists, group.dataset.optionKind === 'weight' ? selected[optionGroups.findIndex(item => item.dataset.optionKind === 'color')] : '');
        });
      });
      const price = document.querySelector('[data-price]');
      if (price) price.textContent = variant ? money(variant.price) : `${messages.from || ''} ${money(Number(messages.minPrice || 0))}`.trim();
      const imageVariant = variant || (selected.some(Boolean) ? variants.find(candidate => candidate.featured_image && selected.every((value, index) => !value || candidate.options[index] === value)) : null);
      const variantImage = imageVariant?.featured_image;
      const imageKey = variantImage?.id || variantImage?.src;
      if (imageKey && imageKey !== lastVariantImage) {
        const thumb = galleryThumbs.find(button => button.dataset.imageId === String(variantImage.id));
        if (thumb) selectGalleryImage(thumb);
        else {
          const main = gallery?.querySelector('#kb-product-image');
          if (main && variantImage.src) {
            main.removeAttribute('srcset');
            main.removeAttribute('sizes');
            main.src = variantImage.src;
            main.alt = variantImage.alt || '';
          }
        }
        lastVariantImage = imageKey;
      }
      syncGalleryColor(selected[optionGroups.findIndex(group => group.dataset.optionKind === 'color')], Boolean(variantImage?.id || variantImage?.src));
    };
    optionGroups.forEach(group => group.addEventListener('change', () => {
      errorMessage.hidden = true;
      optionGroups.forEach(item => item.removeAttribute('aria-invalid'));
      sync();
    }));
    form.querySelector('[data-qty-minus]')?.addEventListener('click', () => { const input = form.querySelector('[name=quantity]'); input.value = Math.max(1, Number(input.value || 1) - 1); });
    form.querySelector('[data-qty-plus]')?.addEventListener('click', () => { const input = form.querySelector('[name=quantity]'); input.value = Number(input.value || 1) + 1; });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (submit.disabled) return;
      errorMessage.hidden = true;
      const missing = optionGroups.find(group => !group.querySelector('input:checked'));
      if (missing) {
        missing.setAttribute('aria-invalid', 'true');
        showProductError(`${messages.missing}: ${missing.dataset.optionName}.`);
        return;
      }
      const variant = selectedVariant();
      if (!variant || !variant.available) { showProductError(messages.unavailable); return; }
      const quantity = Number(form.querySelector('[name=quantity]')?.value);
      if (!Number.isInteger(quantity) || quantity < 1) { showProductError(messages.invalidQuantity); return; }
      submit.disabled = true;
      const root = window.Shopify?.routes?.root || '/';
      try {
        const itemData = new FormData();
        itemData.set('id', idField.value);
        itemData.set('quantity', String(quantity));
        const response = await fetch(`${root}cart/add.js`, { method: 'POST', body: itemData, headers: { Accept: 'application/json' } });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || messages.addError);
        await openCart();
      } catch (error) {
        showProductError(error.message || messages.addError);
      } finally {
        sync();
      }
    });
    sync();
  }
  if (form?.querySelector('[data-size-picker]')) {
    const picker = form.querySelector('[data-size-picker]');
    const config = JSON.parse(form.querySelector('[data-size-config]').textContent);
    const text = config.text;
    const catalogDiscountVariants = new Set(config.discountVariantIds || []);
    const variants = JSON.parse(document.querySelector('[data-kb-variants]').textContent);
    const groups = [...form.querySelectorAll('[data-option-position]')];
    const inputs = [...picker.querySelectorAll('[data-size-quantity]')];
    const sizeIndex = Number(picker.dataset.sizePosition) - 1;
    const submit = form.querySelector('[data-add-button]');
    const error = form.querySelector('[data-product-error]');
    const messages = form.querySelector('[data-product-message]').dataset;
    const root = window.Shopify?.routes?.root || '/';
    const formatPrice = cents => new Intl.NumberFormat(document.documentElement.lang.startsWith('es') ? 'es-MX' : document.documentElement.lang || 'en', { style: 'currency', currency: config.currency || 'MXN' }).format(cents / 100);
    const view = selector => picker.querySelector(selector);
    const interpolate = (template, values) => Object.entries(values).reduce((value, [key, replacement]) => value.replaceAll(`[${key}]`, replacement), template);
    let cartCount = config.cartCount;
    let busy = false;
    let lastImage;
    let cartRevision = 0;
    const selected = () => groups.map(group => ({ group, index: Number(group.dataset.optionPosition) - 1, value: group.querySelector('input:checked')?.value || '' }));
    const matches = (variant, choices) => choices.every(choice => !choice.value || variant.options[choice.index] === choice.value);
    const quantity = input => input.value.trim() === '' ? 0 : Number(input.value);
    const validQuantity = input => Number.isSafeInteger(quantity(input)) && quantity(input) >= 0;
    const isLarge = input => ['2XL', '3XL'].includes(input.dataset.size);
    const variantFor = (input, choices) => {
      if (isLarge(input) && choices.find(choice => choice.group.dataset.optionKind === 'weight')?.value !== '300 g') return undefined;
      return variants.find(variant => variant.options[sizeIndex] === input.dataset.size && matches(variant, choices));
    };
    const selectable = variant => Boolean(variant?.available);
    const errorText = message => { error.textContent = message; error.hidden = false; error.focus(); };
    const sync = () => {
      const choices = selected();
      inputs.filter(isLarge).forEach(input => { if (!selectable(variantFor(input, choices))) input.value = '0'; });
      const hasLarge = inputs.some(input => quantity(input) > 0 && isLarge(input));
      view('[data-large-size-note]').hidden = !hasLarge;
      const complete = choices.every(choice => choice.value);
      const valid = inputs.every(validQuantity);
      const count = valid ? inputs.reduce((sum, input) => sum + quantity(input), 0) : 0;
      const allAvailable = inputs.every(input => !quantity(input) || selectable(variantFor(input, choices)));
      groups.forEach(group => {
        const index = Number(group.dataset.optionPosition) - 1;
        group.querySelector('[data-option-choice]').textContent = choices.find(choice => choice.index === index)?.value || '';
        group.querySelectorAll('input').forEach(input => {
          const dependencies = choices.filter(choice => choice.index !== index && (group.dataset.optionKind !== 'color'));
          const possible = variants.some(variant => variant.available && variant.options[index] === input.value && matches(variant, dependencies));
          input.disabled = busy || !possible;
          input.closest('label').classList.toggle('kb-option-choice--unavailable', !possible);
          const exists = variants.some(variant => variant.options[index] === input.value && matches(variant, dependencies));
          window.KBAvailability.option(input, possible, exists, group.dataset.optionKind === 'weight' ? choices.find(choice => choice.group.dataset.optionKind === 'color')?.value : '');
        });
      });
      inputs.forEach(input => {
        const card = input.closest('[data-size-card]');
        const variant = variantFor(input, choices);
        const available = complete && selectable(variant);
        const status = window.KBAvailability.state({ complete, color: choices.find(choice => choice.group.dataset.optionKind === 'color')?.value, weight: choices.find(choice => choice.group.dataset.optionKind === 'weight')?.value, large: isLarge(input), exists: Boolean(variant), available });
        card.classList.toggle('is-selected', quantity(input) > 0);
        window.KBAvailability.size(input, status);
        input.disabled = busy || !available;
        input.setAttribute('aria-invalid', String(!validQuantity(input) || (quantity(input) > 0 && !available)));
        card.querySelector('[data-size-step="-1"]').disabled = busy || quantity(input) <= 0;
        card.querySelector('[data-size-step="1"]').disabled = busy || !available;
      });
      submit.disabled = busy || !complete || !valid || !count || !allAvailable;
      submit.textContent = busy ? text.adding : count > 1 ? interpolate(text.addMany, { count }) : count === 1 ? text.addOne : text.add;
      const sample = variants.find(variant => variant.available && matches(variant, choices));
      const topPrice = document.querySelector('[data-price]');
      if (topPrice) topPrice.textContent = complete && sample ? formatPrice(sample.price) : `${messages.from} ${formatPrice(Number(messages.minPrice))}`;
      if (topPrice && complete && hasLarge) {
        const prices = inputs.filter(input => quantity(input) > 0).map(input => variantFor(input, choices)?.price).filter(Number.isFinite);
        const low = Math.min(...prices), high = Math.max(...prices);
        topPrice.textContent = low === high ? formatPrice(low) : `${formatPrice(low)} - ${formatPrice(high)}`;
      }
      const variantImage = sample?.featured_image;
      if (choices.some(choice => choice.value) && variantImage && variantImage.id !== lastImage) {
        const thumb = galleryThumbs.find(button => button.dataset.imageId === String(variantImage.id));
        if (thumb) selectGalleryImage(thumb);
        lastImage = variantImage.id;
      }
      syncGalleryColor(choices.find(choice => choice.group.dataset.optionKind === 'color')?.value, Boolean(variantImage && galleryThumbs.some(button => button.dataset.imageId === String(variantImage.id))));
      const ready = complete && valid && count > 0 && allAvailable;
      view('[data-size-estimate]').hidden = !ready;
      view('[data-size-empty]').hidden = ready;
      view('[data-size-empty]').textContent = !valid ? text.invalid : !complete ? text.choose : !allAvailable ? text.unavailable : text.empty;
      if (!ready) return;
      const totalCount = cartCount + count;
      const tier = totalCount >= 31 ? 'ultra' : totalCount >= 12 ? 'medium' : totalCount >= 3 ? 'mini' : 'retail';
      const weight = choices.find(choice => choice.group.dataset.optionKind === 'weight')?.value;
      const rates = config.prices[weight];
      const lines = inputs.filter(input => quantity(input) > 0).map(input => ({ variant: variantFor(input, choices), quantity: quantity(input), large: isLarge(input) }));
      const regularLines = lines.filter(line => !line.large);
      const useRates = config.currency === 'MXN' && rates?.[tier] > 0 && regularLines.length > 0 && regularLines.every(line => line.variant.price === rates.retail && catalogDiscountVariants.has(line.variant.id));
      const totals = lines.reduce((sum, line) => {
        const unit = useRates && !line.large ? rates[tier] : line.variant.price;
        sum.original += line.variant.price * line.quantity;
        sum.total += unit * line.quantity;
        sum.prices.push(unit);
        return sum;
      }, { original: 0, total: 0, prices: [] });
      const saving = totals.original - totals.total;
      const unitPrice = Math.min(...totals.prices);
      const samePrice = totals.prices.every(price => price === unitPrice);
      view('[data-size-description]').textContent = `${interpolate(count === 1 ? text.one : text.many, { count })} · ${choices.map(choice => choice.value).join(' · ')}`;
      view('[data-size-tier]').textContent = hasLarge && !regularLines.length ? text.largeFixed : (useRates ? text[tier] : text.regularFixed);
      view('[data-size-original]').hidden = saving <= 0 || !samePrice;
      view('[data-size-original]').textContent = formatPrice(totals.original / count);
      view('[data-size-unit]').textContent = `${samePrice ? '' : `${messages.from} `}${formatPrice(unitPrice)}`;
      view('[data-size-saving]').hidden = saving <= 0 || !samePrice;
      view('[data-size-saving]').textContent = interpolate(text.unitSaving, { amount: formatPrice(saving / count) });
      const originalTotal = view('[data-size-total-original]');
      if (originalTotal) {
        originalTotal.hidden = saving <= 0;
        originalTotal.textContent = formatPrice(totals.original);
      }
      view('[data-size-total]').textContent = formatPrice(totals.total);
      view('[data-size-total-saving]').hidden = saving <= 0;
      view('[data-size-total-saving]').textContent = interpolate(text.totalSaving, { amount: formatPrice(saving) });
      view('[data-size-context]').textContent = interpolate(cartCount > 0 ? text.context : text.contextEmpty, { existing: cartCount, selected: count, total: totalCount });
      view('[data-size-next]').hidden = !useRates;
      const nextThreshold = totalCount < 3 ? 3 : totalCount < 12 ? 12 : 31;
      const nextTier = totalCount < 3 ? 'mini' : totalCount < 12 ? 'medium' : 'ultra';
      view('[data-size-next]').textContent = tier === 'ultra' ? text.maximum : interpolate(text.next, { count: nextThreshold - totalCount, price: formatPrice(rates?.[nextTier] || 0) });
    };
    groups.forEach(group => {
      if (group.querySelectorAll('input').length === 1) group.querySelector('input').checked = true;
      group.addEventListener('change', () => {
        error.hidden = true;
        if (group.dataset.optionKind === 'color') {
          const color = selected().filter(choice => choice.group.dataset.optionKind === 'color');
          groups.filter(other => other !== group).forEach(other => {
            const checked = other.querySelector('input:checked');
            const index = Number(other.dataset.optionPosition) - 1;
            if (checked && !variants.some(variant => variant.available && variant.options[index] === checked.value && matches(variant, color))) checked.checked = false;
          });
        }
        sync();
      });
    });
    inputs.forEach(input => {
      input.addEventListener('input', () => { error.hidden = true; sync(); });
      input.addEventListener('change', () => { if (!input.value.trim()) input.value = '0'; sync(); });
      input.closest('[data-size-card]').querySelectorAll('[data-size-step]').forEach(button => button.addEventListener('click', () => {
        const base = validQuantity(input) ? quantity(input) : 0;
        input.value = String(Math.max(0, base + Number(button.dataset.sizeStep)));
        error.hidden = true;
        sync();
      }));
    });
    document.addEventListener('kb:cart-updated', event => {
      if (!Number.isSafeInteger(event.detail?.item_count)) return;
      cartRevision++;
      cartCount = event.detail.item_count;
      sync();
    });
    const refreshCount = async () => {
      const revision = cartRevision;
      try {
        const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
        if (!response.ok) return;
        const cart = await response.json();
        if (cartRevision !== revision) return;
        cartCount = cart.item_count;
        sync();
      } catch (_) {}
    };
    window.addEventListener('pageshow', event => { if (event.persisted) refreshCount(); });
    document.addEventListener('visibilitychange', () => { if (!document.hidden) refreshCount(); });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy) return;
      const choices = selected();
      if (submit.disabled) return;
      if (!inputs.every(validQuantity)) { errorText(text.invalid); return; }
      const items = inputs.filter(input => quantity(input) > 0).map(input => ({ id: variantFor(input, choices)?.id, quantity: quantity(input) }));
      if (!items.length || items.some(item => !item.id)) { errorText(text.unavailable); return; }
      busy = true;
      error.hidden = true;
      form.setAttribute('aria-busy', 'true');
      sync();
      try {
        const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || messages.addError);
        inputs.forEach(input => { input.value = '0'; });
        cartRevision++;
        cartCount += items.reduce((sum, item) => sum + item.quantity, 0);
        await openCart();
      } catch (failure) {
        errorText(failure.message || messages.addError);
        await refreshCount();
      } finally {
        busy = false;
        form.removeAttribute('aria-busy');
        sync();
      }
    });
    sync();
    refreshCount();
  }

  const dialog = document.querySelector('#kb-size-guide');
  document.querySelector('[data-size-guide]')?.addEventListener('click', () => dialog?.showModal());
  document.querySelector('[data-dialog-close]')?.addEventListener('click', () => dialog?.close());

  const header = document.querySelector('.kb-header');
  const syncHeader = () => header?.classList.toggle('kb-header--scrolled', window.scrollY > 24);
  syncHeader();
  window.addEventListener('scroll', syncHeader, { passive: true });

  const mobileCards = window.matchMedia('(max-width: 700px)');
  const isMobileCardView = () => mobileCards.matches && (window.matchMedia('(hover: none)').matches || new URLSearchParams(window.location.search).has('oseid'));
  const waitingBacks = new WeakSet();
  let backFrame = 0;
  const updateBacks = () => {
    backFrame = 0;
    const mobile = isMobileCardView() && window.scrollY >= 4 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const startTop = window.innerHeight * .56;
    const travel = window.innerHeight * .46;
    document.querySelectorAll('.kb-grid').forEach(grid => {
      const cards = [...grid.children].filter(child => child.classList.contains('kb-card'));
      cards.forEach((article, index) => {
        const card = article.querySelector('.kb-card__image--has-back');
        if (!card) return;
        if (!mobile) {
          card.classList.remove('is-scroll-back');
          return;
        }
        const rowImage = cards[index - index % 2].querySelector('.kb-card__image');
        const progress = (startTop - rowImage.getBoundingClientRect().top) / travel;
        const showBack = index % 2 === 0 ? progress >= .14 && progress < .52 : progress >= .56 && progress < .94;
        const back = card.querySelector('.kb-card__back');
        card.classList.toggle('is-scroll-back', showBack && back.complete && back.naturalWidth > 0);
        if (showBack && !back.complete && !waitingBacks.has(card)) {
          waitingBacks.add(card);
          back.addEventListener('load', () => {
            waitingBacks.delete(card);
            scheduleBacks();
          }, { once: true });
        }
      });
    });
  };
  const scheduleBacks = () => {
    if (!backFrame) backFrame = requestAnimationFrame(updateBacks);
  };
  window.addEventListener('scroll', scheduleBacks, { passive: true });
  window.addEventListener('resize', scheduleBacks);
  mobileCards.addEventListener('change', scheduleBacks);
  document.addEventListener('shopify:section:load', scheduleBacks);
  if (window.scrollY >= 4) scheduleBacks();

  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const revealObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('kb-reveal-visible');
        revealObserver.unobserve(entry.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });
    const watchReveals = root => {
      root.querySelectorAll('[data-reveal]').forEach(element => {
        if (element.getBoundingClientRect().top > window.innerHeight * 0.88) {
          element.classList.add('kb-reveal-pending');
          revealObserver.observe(element);
        }
      });
    };
    watchReveals(document);
    document.addEventListener('shopify:section:load', event => watchReveals(event.target));
  }
});



